import { render } from "./Admin_Proveedor_Orden.vue?vue&type=template&id=63f31e01"
import script from "./Admin_Proveedor_Orden.vue?vue&type=script&lang=js"
export * from "./Admin_Proveedor_Orden.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__